export enum ERROR_INFO {
  ERROR_ONE = 'error-one',
  ERROR_DOUBLE = 'error-double',
}
